module.exports = __webpack_public_path__ + "img/EXTERIOR-CIAZ-1.47b04c4b.jpg";